import type { MeResponse } from '@an-crm/shared';

/** True during a Super Admin support session: everything is view-only. */
export function isReadOnly(me: MeResponse): boolean {
  return me.support !== null && me.support !== undefined;
}

export function hasPermission(me: MeResponse, permission: string): boolean {
  return me.user.isPlatformAdmin || me.permissions.includes(permission);
}

/** Whether a mutating control guarded by `permission` should be offered at all. */
export function canMutate(me: MeResponse, permission?: string): boolean {
  if (isReadOnly(me)) return false;
  return permission ? hasPermission(me, permission) : true;
}
